import {
  StyledPageContainer,
  StyledPaywallContainer,
} from 'fitify-ui-onboarding/src/components/Paywall/Paywall.Styled'
import { usePromoContext } from 'fitify-ui-onboarding/src/contexts/PromoContext'
import type {
  SubscriptionPageConfig,
  SubscriptionProvider,
} from 'fitify-ui-onboarding/src/types/subscription'
import type { ReactNode } from 'react'

import { DEFAULT_PROMO_CODE } from 'data/promo'
import { useFunnel } from 'hooks/useFunnel'
import { SubscriptionSections } from 'sections/subscription/Content/SubscriptionSections'
import { GoalComparison } from 'sections/subscription/GoalComparison/GoalComparison'
import { PromoImage } from 'sections/subscription/PromoImage/PromoImage'

import { PlanLoader } from '../Plan/PlanLoader'

export type PaymentContentOrderType =
  | 'checkout_first'
  | 'proof_before_checkout'
  | 'benefits_first'
  | 'compact_safe_checkout_guarantee'
  | 'compact_money_guarantee'

type Props = {
  bottomPlanComponent?: ReactNode
  checkoutComponent?: ReactNode
  pageConfig?: SubscriptionPageConfig
  paymentContentOrderType?: PaymentContentOrderType
  subscriptionProvider?: SubscriptionProvider
  topPlanComponent?: ReactNode
}

export const SubscriptionContent = ({
  bottomPlanComponent,
  checkoutComponent,
  pageConfig,
  paymentContentOrderType = 'checkout_first',
  subscriptionProvider,
  topPlanComponent,
}: Props) => {
  const funnel = useFunnel()
  const { promoCode } = usePromoContext()

  const shouldShowGoalComparison = Boolean(
    !promoCode || promoCode === DEFAULT_PROMO_CODE
  )

  return (
    <StyledPageContainer>
      {pageConfig && Boolean(promoCode) && (
        <PromoImage pageConfig={pageConfig} />
      )}
      <StyledPaywallContainer>
        {shouldShowGoalComparison && funnel && (
          <GoalComparison funnel={funnel} />
        )}
        <SubscriptionSections
          bottomPlan={
            subscriptionProvider?.arePlansLoaded && bottomPlanComponent ? (
              bottomPlanComponent
            ) : (
              <PlanLoader planTitle={pageConfig?.planTitle} />
            )
          }
          checkout={subscriptionProvider?.arePlansLoaded && checkoutComponent}
          paymentContentOrderType={paymentContentOrderType}
          topPlan={
            subscriptionProvider?.arePlansLoaded && topPlanComponent ? (
              topPlanComponent
            ) : (
              <PlanLoader planTitle={pageConfig?.planTitle} />
            )
          }
        />
      </StyledPaywallContainer>
    </StyledPageContainer>
  )
}
